var map = {
	"./google-laurel-da-DK.svg": 13876,
	"./google-laurel-de-DE.svg": 32310,
	"./google-laurel-en-GB.svg": 5612,
	"./google-laurel-en-US.svg": 65431,
	"./google-laurel-es-ES.svg": 66912,
	"./google-laurel-es-MX.svg": 58163,
	"./google-laurel-fr-FR.svg": 41944,
	"./google-laurel-it-IT.svg": 24334,
	"./google-laurel-nb-NO.svg": 19477,
	"./google-laurel-nl-NL.svg": 69332,
	"./google-laurel-pl-PL.svg": 42380,
	"./google-laurel-pt-BR.svg": 98624,
	"./google-laurel-pt-PT.svg": 19980,
	"./google-laurel-sv-SE.svg": 5309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;